/* Component Dependencies */
var promotionLandingTemplate = require('templates/promotionLanding.hbs');
var AriesComponent = require('libs/aries-component');
var DomUtilities = require('utils/dom-utilities');
var MDLAttributesHandler = require('libs/mdl-attributes-handler');

AriesComponent.create({
  type: 'promotionLanding',
  template: {
    'promotionLanding': promotionLandingTemplate
  },
  bindEvents: function() {
    var _self = this;
  	if (_self.$el.data('send-attribute')) {      
  		MDLAttributesHandler.fetchMDLAttributes(_self);
    }
    
    //Impression Tracking for promotionLanding page for signin and join now links
    var customClickTrackBtn = $('.l-description-heading a').first();
    var url = customClickTrackBtn.attr('href').split('?')[0];
    switch (url) {
      case "/loyalty/join/joinPromotion.mi": {
        customClickTrackBtn.addClass("custom_click_track").attr("custom_click_track_value", "Marriott Bonvoy PromotionLanding Tile|Join for Free|internal|event167,evar48=MER-web-promotionsLanding-joinnow");
        break;
      }
      case "/sign-in.mi":{
        customClickTrackBtn.addClass("custom_click_track").attr("custom_click_track_value", "Marriott Bonvoy PromotionLanding Tile|Sign In|internal|event167,evar48=MER-web-promotionsLanding-signin");
        break;
      }
      default: { };
    }
  } 
});
